var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.679,
    height: 18,
    viewBox: "0 0 18.679 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .calendarColored{fill:#1bc47d}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18279",
    "data-name": "Group 18279",
    transform: "translate(-511.082 -640.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8525",
    "data-name": "Path 8525",
    d: "M515.211 640.159a.782.782 0 0 1 .782.782v1.739a49.91 49.91 0 0 1 8.86 0v-1.739a.782.782 0 0 1 1.563 0v1.894a3.517 3.517 0 0 1 2.993 3.021l.091.681a30.219 30.219 0 0 1-.1 8.618 3.135 3.135 0 0 1-2.791 2.639l-1.243.123a50.407 50.407 0 0 1-9.889 0l-1.243-.123a3.136 3.136 0 0 1-2.792-2.639 30.218 30.218 0 0 1-.1-8.618l.091-.681a3.517 3.517 0 0 1 2.994-3.021v-1.894a.782.782 0 0 1 .784-.782zm.464 4.12a48.337 48.337 0 0 1 9.5 0l.943.093a1.955 1.955 0 0 1 1.746 1.689l.091.681c.031.238.059.476.085.714h-15.231c.025-.238.054-.476.085-.714l.091-.681a1.955 1.955 0 0 1 1.746-1.689zm-2.989 4.739a28.614 28.614 0 0 0 .3 5.894 1.573 1.573 0 0 0 1.4 1.325l1.243.122a48.736 48.736 0 0 0 9.583 0l1.243-.122a1.574 1.574 0 0 0 1.4-1.325 28.618 28.618 0 0 0 .3-5.894z",
    style: {
      fill: "#8c8d99",
      fillRule: "evenodd"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    className: "calendarColored",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(515.099 650.017)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    className: "calendarColored",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(519.67 650.017)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_286",
    "data-name": "Ellipse 286",
    className: "calendarColored",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(524.229 650.017)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    className: "calendarColored",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(515.099 652.807)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    className: "calendarColored",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(519.67 652.807)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    className: "calendarColored",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    transform: "translate(524.229 652.807)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarColored);
export default __webpack_public_path__ + "static/media/calendar-colored.43960ea00ac47042a588571a2ba5756d.svg";
export { ForwardRef as ReactComponent };